<app-full-page-message *ngIf="localService.isServiceProviderBlocked()"></app-full-page-message>
<div class="{{localService.selectedLanguageCode}}"
  *ngIf="!localService.isServiceProviderBlocked() && localService.languageContent && localService.languageContent.sms_settings && notificationTypes &&  wrapper">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div style="max-width:1200px;" class="banner center">
    <div class="row">
      <div class="col-md-6">
        <ngx-select style="width:200px;float:left;" [(ngModel)]="selectedNotificationType" [optionValueField]="'key'"
          [optionTextField]="'value'" [items]="notificationTypes" [noAutoComplete]="true" (select)="onLoad()">
        </ngx-select>
        &nbsp;
        <label>{{localService.languageContent.sms_settings.current_credits}}</label>
        <span class="en">&nbsp;:&nbsp;{{availableCredits}}&nbsp;&nbsp;</span>
        <i class="material-icons icon_adjust" style="top:6px;" (click)="onAction(2)"
          title="{{localService.languageContent.sms_settings.add_credits}}">add_circle_outline</i>
      </div>
      <div class="col-md-6">
        <div *ngIf="source" style="text-align: right;">
          <label style="font-weight: normal; margin-right: 10px;margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isActive" [disabled]="!isShowActive" />
            <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
          </label>
          <app-label [Text]="localService.languageContent.sms_settings.alert_limit" [IsColonRequired]="true" />
          <input autocomplete="off" type="number" class="number" [ngClass]="source.content.value ? 'en' : ''"
            [(ngModel)]="source.content.value" (keypress)="localService.isNumberOnly($event)"
            placeholder="{{localService.languageContent.sms_settings.alert_limit}}"
            title="{{localService.languageContent.sms_settings.alert_limit}}" style="width: 100px;" />
          &nbsp;
          <button type="button" class="btn btn-primary"
            (click)="onSave()">{{localService.languageContent.common.save}}</button>
        </div>
      </div>
    </div>
    <div class="row row_header freeze_col freeze_height">
      <div class="col-4">
        <span>{{localService.languageContent.sms_settings.sent_on}}</span>
      </div>
      <div class="col-8">
        <span>{{localService.languageContent.sms_settings.message}}&nbsp;({{wrapper.paging.totalCount}})</span>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-md-4 en">
          {{item.v1 | localDate : 'time'}}&nbsp;({{item.v5}});&nbsp;{{item.v4}}
        </div>
        <div class="col-md-8" [ngClass]="localService.getLanguageCode(item.v2)">
          <div [innerHtml]="item.v3"></div>
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()" (onDateSelected)="onDateSelected()"></app-paging>
</div>